import type { StaffOverview } from "../../shared/staff.js";

const daysAgo = (days: number) => new Date(Date.now() - days * 86_400_000).toISOString();
const you = {
  id: "00000000-0000-4000-8000-000000000001",
  name: "Alex Devon",
  email: "alex@evidite.com"
};

const minutesAgo = (minutes: number) => new Date(Date.now() - minutes * 60_000).toISOString();

const demoRoles = [
  ["billing", "Billing operations", ["accounts.read", "wallets.adjust"]],
  ["investor_relations", "Investor relations", ["investors.read", "investors.write"]],
  ["operations", "Product operations", ["cache.invalidate", "cache.read", "telemetry.read"]],
  ["platform_admin", "Platform administrator", ["accounts.manage", "staff.manage"]],
  ["stacks_operator", "Stacks operator", ["stacks.read", "stacks.search"]],
  ["support", "Customer support", ["accounts.manage", "accounts.read", "invitations.manage"]]
] as const;

/** Synthetic staff for the demo and browser tests: no real people or addresses. */
export function demoStaffOverview(): Extract<StaffOverview, { available: true }> {
  return {
    available: true,
    you: you.id,
    freshUntil: new Date(Date.now() + 7 * 60_000).toISOString(),
    roles: demoRoles.map(([role, displayName, permissions]) => ({
      role,
      displayName,
      permissions: [...permissions],
      consoleManaged: role !== "platform_admin"
    })),
    staff: [
      {
        userId: you.id,
        email: you.email,
        name: you.name,
        accountStatus: "active",
        twoFactorEnabled: true,
        roles: [{ role: "platform_admin", assignedAt: daysAgo(32), assignedBy: you.email }]
      },
      {
        userId: "20000000-0000-4000-8000-000000000002",
        email: "rowan.reviewer@evidite.example",
        name: "Rowan Reviewer",
        accountStatus: "active",
        twoFactorEnabled: false,
        secureSignIn: "passkey",
        roles: [{ role: "stacks_operator", assignedAt: daysAgo(1), assignedBy: you.email }]
      },
      {
        userId: "20000000-0000-4000-8000-000000000003",
        email: "casey.support@evidite.example",
        name: "Casey Support",
        accountStatus: "active",
        twoFactorEnabled: true,
        roles: [
          { role: "stacks_operator", assignedAt: daysAgo(6), assignedBy: you.email },
          { role: "support", assignedAt: daysAgo(14), assignedBy: you.email }
        ]
      }
    ],
    history: [
      {
        id: "30000000-0000-4000-8000-000000000001",
        action: "revoked",
        role: "stacks_operator",
        source: "admin_console",
        actor: you.email,
        target: "morgan.former@evidite.example",
        occurredAt: minutesAgo(40)
      },
      {
        id: "30000000-0000-4000-8000-000000000002",
        action: "granted",
        role: "stacks_operator",
        source: "admin_console",
        actor: you.email,
        target: "rowan.reviewer@evidite.example",
        occurredAt: daysAgo(1)
      },
      {
        id: "30000000-0000-4000-8000-000000000003",
        action: "granted",
        role: "stacks_operator",
        source: "staff_command",
        actor: you.email,
        target: "casey.support@evidite.example",
        occurredAt: daysAgo(6)
      },
      {
        id: "30000000-0000-4000-8000-000000000004",
        action: "granted",
        role: "support",
        source: "staff_command",
        actor: you.email,
        target: "casey.support@evidite.example",
        occurredAt: daysAgo(14)
      }
    ]
  };
}
